import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck } from 'lucide-react';
const FiveStars = () => <div className="flex gap-0.5 mb-4" data-id="element-241">
    {[...Array(5)].map((_, i) => <Star key={i} className="text-brand-gold fill-current" size={18} data-id="element-242" />)}
  </div>;
const fullTestimonials = [{
  initials: 'MP',
  name: 'María P.',
  city: 'Buenos Aires 🇦🇷',
  quote: 'Compré un sábado. El domingo a la noche tenía el mes de sesiones listo. Nunca más improviso.'
}, {
  initials: 'CG',
  name: 'Claudia G.',
  city: 'Córdoba 🇦🇷',
  quote: 'Tres alumnos intermedios que estaban estancados progresaron en el primer mes con el Tomo 2. Mis alumnos me preguntan qué cambié.'
}, {
  initials: 'FR',
  name: 'Federico R.',
  city: 'Rosario 🇦🇷',
  quote: 'Antes tardaba 1 hora armando una sesión. Ahora son 5 minutos. Ese tiempo ahora lo uso para conseguir más alumnos.'
}, {
  initials: 'SV',
  name: 'Sofía V.',
  city: 'Mendoza 🇦🇷',
  quote: 'El Bonus de Anatomía cambió cómo corrijo a mis alumnos en el Reformer. Ahora sé exactamente qué músculo trabajar y qué cue dar. Mis alumnos lo notan.'
}, {
  initials: 'DA',
  name: 'Diego A.',
  city: 'Santa Fe 🇦🇷',
  quote: 'El Checklist de Seguridad me salvó con una alumna con hernia lumbar. Supe exactamente qué hacer en cada sesión sin improvisar con su salud.'
}, {
  initials: 'CR',
  name: 'Carolina R.',
  city: 'Tucumán 🇦🇷',
  quote: 'El Calendario de las 1.000 Sesiones cambió mi relación con la enseñanza. Llego al estudio sabiendo exactamente qué voy a dar. Sin ansiedad. Sin culpa.'
}];
export const Social = () => {
  return <section className="py-20 bg-brand-cream" data-id="element-243">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-244">
        {/* Testimonials Grid */}
        <div className="text-center mb-16" data-id="element-245">
          <h2 className="text-4xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-246">
            Lo que dicen los profesores
          </h2>
          <div className="flex items-center justify-center gap-2 text-2xl font-bold text-brand-charcoal" data-id="element-247">
            4.9/5 <Star className="text-brand-gold fill-current" size={28} data-id="element-248" />
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-24" data-id="element-249">
          {fullTestimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-brand-sand" data-id="element-250">
              <FiveStars data-id="element-251" />
              <div className="flex items-center gap-4 mb-6" data-id="element-252">
                <div className="w-12 h-12 bg-brand-charcoal text-white rounded-full flex items-center justify-center font-serif font-bold text-xl" data-id="element-253">
                  {t.initials}
                </div>
                <div data-id="element-254">
                  <div className="font-bold text-brand-charcoal" data-id="element-255">{t.name}</div>
                  <div className="text-sm text-gray-500" data-id="element-256">{t.city}</div>
                </div>
              </div>
              <p className="text-gray-700 italic leading-relaxed" data-id="element-257">
                "{t.quote}"
              </p>
            </motion.div>)}
        </div>

        {/* Guarantee */}
        <div className="max-w-3xl mx-auto bg-white rounded-3xl p-10 md:p-16 text-center shadow-xl border border-brand-sand" data-id="element-258">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 text-green-600 rounded-full mb-8" data-id="element-259">
            <ShieldCheck size={40} data-id="element-260" />
          </div>
          <h3 className="text-3xl font-serif font-bold text-brand-charcoal mb-6" data-id="element-261">
            🛡️ Garantía 7 días sin preguntas
          </h3>
          <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-262">
            Abrí los 12 Tomos. Revisá los 6 Bonus. Usá los Ebooks Élite en tu
            clase. <br data-id="element-263" />
            <br data-id="element-264" />
            Si no es lo que esperabas → 100% de devolución. Sin preguntas. Sin
            formularios. Sin drama.
          </p>
          <div className="inline-block bg-brand-sand/30 px-6 py-3 rounded-full font-bold text-brand-charcoal tracking-wide" data-id="element-265">
            TASA DE DEVOLUCIONES MENOR AL 2%
          </div>
        </div>
      </div>
    </section>;
};